import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as display from '../../../display'
import * as tenants from '../../tenants'
import * as zones from '../../zones'
import type { Api } from '../api'
import type { Collection } from '../collection'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** Exposes management inventory and the collection-owned browser selection. */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(collection: Collection, api: Api) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Management',
      parent: collection.feature,
      selectors: () => new Selectors(this, collection),
    })

    const toasterFeature = ngCore.inject(display.toaster.Feature)
    const tenantsApi = ngCore.inject(tenants.Api)
    const zonesApi = ngCore.inject(zones.Api)
    this.registerEffects(
      effects.executeLoad(api),
      effects.executeLoadTenants(tenantsApi),
      effects.executeLoadZones(zonesApi),
      effects.reconcileSelection(collection),
      effects.requestZones(),
      effects.submitUpload(collection),
      effects.handleUploadSuccess(collection),
      effects.handleDeleteSuccess(collection),
      effects.showErrors(toasterFeature),
    )
  }
}
